import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthApi } from '../auth/auth-api';
import { AppRoutes } from '../app.routes';

export const guestGuard: CanActivateFn = () => {
  const authApi = inject(AuthApi);
  const router = inject(Router);

  if (!authApi.isAuthenticated()) {
    return true;
  }

  router.navigate([AppRoutes.SHUTTLE]);
  return false;
};
